import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/content/content-item-render";
import type { searchContentItemContent$key } from "~/queries/__generated__/searchContentItemContent.graphql";

import { Container, Cover, Headline, Overlay, StyledEntityLink } from "./styles";

export type Props = {
  className?: string;
  provider: DefaultComponentsProvider;
  reference: searchContentItemContent$key;
};

export const ContentItemMorningStudio = forwardRef<HTMLDivElement, Props>(
  ({ className, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment morningStudioContentItemContent on Content {
          ...entityLink
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content}>
          <Cover>
            {provider.coverImage({
              responsiveVariants: {
                desktopUp: "size1200x800",
                mobileUp: "size768x768",
                tabletUp: "size1200x800",
              },
            })}
          </Cover>
          <Overlay />
          <Headline>
            {provider.headline({
              preferSocialHeadline: true,
            })}
          </Headline>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemMorningStudio.displayName = "ContentItemMorningStudio";
